import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import {
  rootRouteRef,
  taskListRouteRef,
  templateIndexRouteRef,
  templateEditorRouteRef,
  actionsRouteRef,
  taskRouteRef,
  iamRouteRef,
} from './routes';

export const platformSettingsPlugin = createPlugin({
  id: 'wb-platform-settings',
  routes: {
    root: rootRouteRef,
    templateIndexRouteRef: templateIndexRouteRef,
    iamRouteRef: iamRouteRef,
    taskListRouteRef: taskListRouteRef,
    templateEditorRouteRef: templateEditorRouteRef,
    actionsRouteRef: actionsRouteRef,
    taskRouteRef: taskRouteRef,
  },
});

/**
 * The Router and main entrypoint to the plugin.
 *
 * @public
 */
export const PlatformSettingsPage = platformSettingsPlugin.provide(
  createRoutableExtension({
    name: 'PlatformSettingsPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
